<template>
  <div
    v-if="isOpen"
    class="relative flex items-center justify-center flex-col lg:flex-row bg-ma-red-3 promo-block px-8 py-5 lg:py-3"
  >
    <p class="text-base text-white flex flex-col lg:flex-row items-center text-center">
      <i class="fa-regular fa-triangle-exclamation text-xl text-white mr-0 lg:mr-2 mb-2 lg:mb-0" />
      <span class="leading-5">Your last payment hasn’t been processed. Update your payment method to keep your license.</span>
    </p>
    <button
      class="inline-flex items-center px-5 mx-3 mt-5 lg:mt-0 border border-white rounded-full text-xs font-bold text-white h-8"
      @click="redirectToPaymentMethod"
    >
      <span>Update Now</span>
    </button>
    <button
      type="button"
      class="absolute close"
      aria-label="Close"
      @click="close"
    >
      <i class="fas fa-times text-white" />
    </button>
  </div>
</template>

<script>
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';
import { SESSION_NAMES } from '@/constants';

export default {
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isDunning() {
      return this.$store.state.subscription?.isDunning;
    },
    isDunningSnackbarClosed() {
      return this.$store.state.subscription?.isDunningSnackbarClosed;
    },
    isDunningPopupClosed() {
      return this.$store.state.subscription?.isDunningPopupClosed;
    },
    openStatus() {
      return this.isLoggedIn && this.isDunning && !this.isDunningSnackbarClosed;
    },
    currentRoute() {
      return this.$router.currentRoute;
    },
    isAdmin() {
      return this.$store.state.user?.is_team_admin;
    },
  },
  watch: {
    isDunningSnackbarClosed() {
      this.isOpen = this.openStatus;
    },
    isDunningPopupClosed() {
      this.isOpen = this.openStatus;
    },
    isOpen(newVal) {
      if (newVal) {
        eventTracker(analyticsEvents.headerStripViewed, {
          strip_name: 'dunning process strip',
          strip_text: 'Your last payment hasn’t been processed. Update your payment method to keep your license.',
        });
      }
    },
  },
  mounted() {
    this.isOpen = this.openStatus;
  },
  methods: {
    close() {
      sessionStorage.setItem(SESSION_NAMES.IS_DUNNING_SNACKBAR_CLOSED, 'true');
      this.$store.dispatch('setIsDunningSnackbarClosed', true);
      eventTracker(analyticsEvents.closeButtonClicked, {
        button_name: 'x',
        click_source: 'dunning process strip',
      });
    },
    redirectToPaymentMethod() {
      const redirectPath = this.isAdmin ? '/account/team/billing/' : '/account/billing/';
      if (this.currentRoute.path !== redirectPath) {
        window.location.href = redirectPath;
      }
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: 'Update payment method',
        click_source: 'payment failed header strip',
        flow: 'dunning process strip',
        next_URL: 'https://motionarray.com/account/billing',
      });
    },
  },
};
</script>

<style scoped>

.close {
  top: 16px;
  right: 20px;
}
</style>
